import { createAsyncReducer } from '../../standard-actions';
import {
    ILoadNbnTestAction,
    ILoadNbnTestSuccessAction,
    ILoadNbnTestErrorAction
} from '../actions/load-nbn-results';
import { IServiceRequestsState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadNbnTestResultAction
    = ILoadNbnTestAction
    | ILoadNbnTestSuccessAction
    | ILoadNbnTestErrorAction

const init = (state: IServiceRequestsState, action: LoadNbnTestResultAction) => ({
    ...state,
    nbnresults: {
        ...initialState.nbnresults,
        status: action.status
    }
});

const success = (state: IServiceRequestsState, action: LoadNbnTestResultAction) => ({
    ...state,
    nbnresults: {
        ...initialState.nbnresults,
        status: action.status,
        data: (action as ILoadNbnTestSuccessAction).data
    }
});

const failure = (state: IServiceRequestsState, action: LoadNbnTestResultAction) => ({
    ...state,
    nbnresults: {
        ...initialState.nbnresults,
        status: action.status,
        error: (action as ILoadNbnTestErrorAction).error
    }
});

export const loadNbnResultsReducer = createAsyncReducer(initialState, init, success, failure);
